import FormType from '@@types/Form';

import i18n from '~/i18n';
import { Form } from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';

class SlashCommandForm extends Form {
  context: {
    api: any;
    appId: string;
    isGov: boolean;
  };

  constructor(data, options, context) {
    super(data, options);
    this.context = context;
  }

  checkTitle(value, __attr, __key, passes) {
    if (!this.context || (this as FormType).$('name').isDefault) return passes();
    this.context.api.command
      .validateDuplicatedIntegrationCommandName({
        appId: this.context.appId,
        name: value,
      })
      .then((isDuplicate: boolean) => {
        if (isDuplicate) {
          passes(false, i18n.t('existAppName', '이미 존재하는 앱 입니다  다른 이름으로 지정해 주세요.'));
        } else {
          passes();
        }
      });
  }

  checkRequestUrl(value, __attr, __key, passes) {
    if (!this.context || (this as FormType).$('requestUrl').isDefault) return passes();
    const REGEX = /^https?:\/\/(?:[A-z]+(?::[0-9A-z]+)?@)?[0-9A-z.\-]+(?::(\d+))?(?:\/|$)/i;
    const result = REGEX.exec(value);
    if (!result) {
      passes(false, i18n.t('form.rule.requestUrl.invalid', '잘못된 RequestUrl 형식입니다.'));
      return;
    }
    if (this.context.isGov && result[1] && result[1] !== '443') {
      passes(false, i18n.t('form.rule.requestUrl.port', '443 포트만 사용할 수 있습니다.'));
      return;
    }
    passes(true);
  }

  options() {
    return {
      validateOnInit: true,
      validateOnChange: true,
      validateOnBlur: false,
    };
  }

  /*
    Below we are returning a `plugins` object using the `validatorjs` package
    to enable `DVR` functionalities (Declarative Validation Rules).
  */
  plugins() {
    return {
      dvr: dvr({
        package: validatorjs,
        extend: ({ validator }) => {
          const messages = validator.getMessages('en');
          messages['required.name'] = i18n.t('form.rule.command.required', 'Command를 입력해 주세요.');
          messages['regex.name'] = i18n.t('form.rule.title.invalid', '잘못된 Command 형식입니다.');
          messages.max = i18n.t('form.rule.max', ':max자 이하로 입력해 주세요.');
          messages.min = i18n.t('form.rule.min', ':min자 이상 입력해 주세요.');
          validator.registerAsync('checkTitle', (value, attr, key, passes) => {
            this.checkTitle(value, attr, key, passes);
          });

          messages['required.requestUrl'] = i18n.t('form.rule.requestUrl.required', 'RequestUrl을 입력해 주세요.');
          validator.registerAsync('checkRequestUrl', (value, attr, key, passes) => {
            this.checkRequestUrl(value, attr, key, passes);
          });
          validator.setMessages('en', messages);
        },
      }),
    };
  }

  /*
    Return the `fields` as a collection into the `setup()` method
    with a `rules` property for the validation.
  */
  setup() {
    return {
      fields: [
        {
          name: 'name',
          rules: 'required|min:2|max:35|regex:/^\\/.*/|checkTitle',
          value: '',
        },
        {
          name: 'requestUrl',
          rules: 'required|checkRequestUrl',
          value: '',
        },
        {
          name: 'description',
          rules: 'required|max:255',
          value: '',
        },
        {
          name: 'parameterHint',
          value: '',
        },
      ],
    };
  }
}

export default SlashCommandForm;
